import React, { useEffect } from 'react';

import { enqueueSnackbar } from 'notistack';

import { isPromoPriceLimited } from '../utils/isPromoPriceLimited/isPromoPriceLimited';

type UsePromoPriceLimitedProps = {
  promoPrice?: number | null;
  finalPrice?: number | null;
};

export const usePromoPriceLimited = ({
  promoPrice,
  finalPrice,
}: UsePromoPriceLimitedProps) => {
  useEffect(() => {
    if (isPromoPriceLimited(promoPrice, finalPrice)) {
      enqueueSnackbar({
        message: (
          <>
            The minimum charge is $0.50 due to Stripe processing fees.
            <br />
            We cannot process payments below this amount because of payment system
            policies
          </>
        ),
        variant: 'info',
      });
    }
  }, [promoPrice, finalPrice]);
};
